'use strict';
const BaseView = require('components-framework/view/base.view');
const withRenderedMain = require('components-framework/view/with_rendered_main');
const loginvalidator = require('od-modules/users/login_validator');
const trackingUtils = require('od-modules/utils/tracking.utils');
const appTouchpointFactory = require('components/app_download/app_touchpoint/js/main');
const loginFactory = require('components/user_area/login/js/main');
const recaptchaManager = require('od-modules/users/recaptcha.js');
const tripdetailsStorageUtils = require('od-modules/utils/tripdetails_storage.utils');

const createWidgetLoader = require('components-framework/widget/create_widget_loader');

module.exports = withRenderedMain(BaseView.extend({
    selectors: {
        checkWithBookingRef: '#checkWithBookingRef',
        emailInput: '#checkWithBookingRef .email_input',
        bookingRefInput: '#checkWithBookingRef .bookingRef_input',
        oneLineInputs: '#checkWithBookingRef .oneline-input',
        mytripsloginInfoError: '#checkWithBookingRef .od-mytripslogin-info .error_message',
        reservationWaiting: '#checkWithBookingRef .reservation_waiting',
        prismaInput: '.prisma_input_group',
        pwdInput: '.password_input',
    },

    events: {
        'tap .checkBooking_button': 'checkBooking',
        'tap .register_page_link': 'goToRegisterPage',
        'tap .mytripslogin_login_button': 'submitLoginRequest',
        'focus #checkWithBookingRef .oneline-input': 'showOneLineLabel',
        'blur #checkWithBookingRef .oneline-input': 'validateOneLine',
        'focus .prisma_input_group': 'onFocusInput',
        'blur .prisma_input_group': 'onBlurInput',
        'focus .prisma-input': 'onFocusInput',
        'blur .prisma-input': 'onBlurInput',
        'tap .password_char_viewer': 'onToggleEyeIcon',
    },

    initialize: function() {
        const isRecaptchaEnabled = Odigeo.AB.isRecaptchaEnabled || Odigeo.AB.isRecaptchaLoginEnabled;
        this.apiCallLimiter = true;
        if (this.$el.find('#app-touchpoint-findyourbooking').length > 0) {
            appTouchpointFactory.create({
                id: 'app-touchpoint-findyourbooking',
                options: {
                    selector: 'findyourbooking',
                    trackAction: 'app_banner',
                    trackCategory: 'sso_sign_in_trips',
                    trackLabel: 'app_download_middle',
                },
            });
        }
        if (isRecaptchaEnabled && !recaptchaManager.isGRecaptchaLoaded) {
            recaptchaManager.init();
        }

        if (this.$el.find('#my-trips-login-form').length > 0) {
            if (Odigeo.AB.isCobaltBoxVariant) {
                const loginWidget = createWidgetLoader({
                    login: ['my-trips-login-form', loginFactory],
                });
                if (isRecaptchaEnabled) {
                    loginWidget.get('login').execute('renderCaptcha', true);
                }
            } else {
                const loginWidget = loginFactory.create({id: 'my-trips-login-form'});
                if (isRecaptchaEnabled) {
                    loginWidget.execute('renderCaptcha', true);
                }
            }
        }
    },

    showOneLineLabel: function(e) {
        $(e.currentTarget).closest('.input_wrapper').toggleClass('showing_label', true).toggleClass('invalid invalid-long', false);
    },
    validateOneLine: function(e) {
        const $input = $(e.currentTarget);
        const errorMsgs = loginvalidator.checkValidity($input, this.$el.find(this.selectors.checkWithBookingRef));
        $input.closest('.input_wrapper').toggleClass('showing_label', Odigeo._.isEmpty(errorMsgs)).toggleClass('invalid invalid-long',
            !Odigeo._.isEmpty(errorMsgs));
    },

    _trackEvent: function(action, label, category) {
        trackingUtils.trackEventWithCategory(category, action, label);
    },

    onFocusInput: function(e) {
        $(e.target).closest(this.selectors.prismaInput).addClass('focused');
    },

    onBlurInput: function(e) {
        $(e.target).closest(this.selectors.prismaInput).removeClass('focused');
    },

    onToggleEyeIcon() {
        this.$el.find(this.selectors.eyeIconPwd).toggleClass('odf-hidden');
        if (this.$el.find(this.selectors.pwdInput).prop('type') === 'password') {
            this.$el.find(this.selectors.pwdInput).prop('type', 'text');
        } else {
            this.$el.find(this.selectors.pwdInput).prop('type', 'password');
        }
    },

    checkBooking: function() {
        let data;
        let fieldErrors;
        const allInputs = this.$el.find(this.selectors.checkWithBookingRef).find('[data-name]:not([type="hidden"])');

        tripdetailsStorageUtils.removeInSessionWithExpirationTime('bookingInfo');

        loginvalidator.clearErrors(allInputs);
        this.$el.find(this.selectors.mytripsloginInfoError).closest('.input_wrapper').toggleClass('invalid invalid-long', false);

        this.$el.find(this.selectors.emailInput).closest('.input_wrapper').removeClass('invalid-no-text');
        fieldErrors = loginvalidator.checkValidity(allInputs, this.$el.find(this.selectors.checkWithBookingRef));
        Odigeo._.each(fieldErrors, function(element) {
            this._trackError(element);
        }, this);
        if (Odigeo._.isEmpty(fieldErrors) && this.apiCallLimiter) {
            data = {
                queryParams: {
                    email: this.$el.find(this.selectors.emailInput).val(),
                    bookingid: this.$el.find(this.selectors.bookingRefInput).val(),
                },
            };
            this._trackEvent('find_booking', 'find_booking_clicks', 'sso_sign_in_trips');
            this.apiCallLimiter = false;
            this.$el.find(this.selectors.reservationWaiting).addClass('open opened');
            Odigeo.trigger(this.id + ':submitUserRequest', {'data': data, 'action': 'getTrip'});
        }
    },

    _loadTrip: function(data) {
        this.$el.find(this.selectors.reservationWaiting).removeClass('open opened');
        Odigeo.trigger(this.id + ':loadTripOK', data);
        this.apiCallLimiter = true;
    },

    _loadTripError: function(data) {
        let labelObject;
        let $selector;
        const error = data && data.messageError && this.model.errors[data.messageError] ? this.model.errors[data.messageError] : 'requestError';
        const errorLabelObjects = {
            bookingNull: {
                label: this.model.trackErrors.bookingRef.invalid,
            },
            emailEmpty: {
                label: this.model.trackErrors.email.empty,
            },
            emailInvalid: {
                label: this.model.trackErrors.email.invalid,
            },
            noBookingFound: {
                label: 'reference_and_email_dont_match_error',
                noTextClass: true,
            },
            defaultError: {
                label: 'request_error',
                noTextClass: true,
            },
        };
        this.$el.find(this.selectors.reservationWaiting).removeClass('open opened');

        this.apiCallLimiter = true;

        $selector =Odigeo._.includes(['emailEmpty', 'emailInvalid'], error) ?
            this.$el.find(this.selectors.emailInput) : this.$el.find(this.selectors.bookingRefInput);

        $selector = this.$el.find(this.selectors.mytripsloginInfoError).length && Odigeo._.includes(['noBookingFound', 'requestError'], error) ?
            this.$el.find(this.selectors.mytripsloginInfoError) : $selector;

        loginvalidator.showError($selector.data(error), $selector.closest('.input_wrapper').toggleClass('showing_label', false));

        labelObject = errorLabelObjects[error] || errorLabelObjects['defaultError'];
        if (labelObject.noTextClass) {
            this.$el.find(this.selectors.emailInput).closest('.input_wrapper').addClass('invalid-no-text');
        }

        this._trackEvent('find_booking_error', labelObject.label, 'sso_sign_in_trips');
    },

    _trackError: function(error) {
        const label = this.model.trackErrors[error.index][error.key];
        this._trackEvent('find_booking_error', label, 'sso_sign_in_trips');
    },

    goToRegisterPage: function() {
        this._trackEvent('sign_in', 'go_to_register', 'sso_sign_in_trips');
        Odigeo.trigger(this.id + ':goToRegisterPage');
    },

    submitLoginRequest: function() {
        this._trackEvent('sign_in', 'sign_in', 'sso_sign_in_trips');
        Odigeo.trigger(this.id + ':submitLoginRequest', {action: 'openModalLogin'});
    },

    actionsHandler: function(action) {
        if (action === 'opencmf') {
            trackingUtils.trackEvent('sign_in_checkin_onload', action);
        }
    },
}));
